import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import MathBlockNode from './MathBlockNode';

export const MathBlockExtension = Node.create({
  name: 'mathBlock',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      latex: {
        default: '',
      },
    };
  },
  
  addOptions() {
    return {
      onMathDoubleClick: (initialValue: string, onSave: (newValue: string) => void) => {},
    }
  },

  parseHTML() {
    return [
      {
        tag: 'math-block',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['math-block', mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(MathBlockNode);
  },
});
